<script setup lang="ts">
import CommonButton from '@/components/common/button/CommonButton.vue'
import { useCommonDialog } from '@/composables/common/dialog/useCommonDIalog'
import { BModal, type ButtonVariant, type Size } from 'bootstrap-vue-next'
const props = defineProps<{
  size?: Size
  okTitle?: string
  cancelTitle?: string
  okOnly?: boolean
  cancelOnly?: boolean
  autofocusButton?: 'ok' | 'cancel' | 'close'
  isEmitOkEvent?: boolean
  variant?: ButtonVariant | null
  okDisabled?: boolean
}>()
const isOpenModel = defineModel<boolean>()
const { isOpen, ok, cancel, openDialog, isOpenComputed } = useCommonDialog(isOpenModel)

const emit = defineEmits<{
  (e: 'ok-event'): void
}>()
const handleOk = () => {
  if (props.isEmitOkEvent) {
    emit('ok-event')
  } else {
    ok()
  }
}
const handleOkConfirmed = () => {
  ok()
}

defineExpose({
  isOpen,
  openDialog,
  handleOkConfirmed
})
</script>

<template>
  <BModal
    v-model="isOpenComputed"
    :size="size"
    :ok-only="okOnly"
    :autofocus-button="autofocusButton"
    :no-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #header>
      <slot name="header"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #footer>
      <CommonButton v-if="!okOnly" size="md" variant="secondary" @click="cancel()">{{
        cancelTitle
      }}</CommonButton>
      <CommonButton
        v-if="!cancelOnly"
        size="md"
        :variant="variant ? variant : 'primary'"
        @click="handleOk()"
        :disabled="okDisabled"
        >{{ okTitle }}</CommonButton
      >
    </template>
  </BModal>
</template>

<style lang="scss" scoped></style>
